// PrensaModal.js
import React from 'react';
import { Modal, Button, Image } from 'react-bootstrap';

function PrensaModal({ show, handleClose, data }) {
  if (!data) return null;

  return (
    <Modal show={show} onHide={handleClose} centered size="lg">
      <Modal.Header closeButton>
        <Modal.Title>{data.titulo}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {/* Imagen del boletín */}
        <Image 
          src={data.imagen} 
          alt={data.titulo} 
          fluid 
          className="mb-3 rounded shadow-sm"
        />

        <p><strong>Fecha:</strong> {data.fecha}</p>
        <p>{data.resumen}</p>
        <a 
          href={data.enlace} 
          target="_blank" 
          rel="noopener noreferrer" 
          className="btn btn-outline-primary mt-3"
        >
          Ver boletín completo
        </a>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>Cerrar</Button>
      </Modal.Footer>
    </Modal>
  );
}

export default PrensaModal;
